import React, { useEffect, useState, useRef } from "react";
import "./NewPreviewUI.css";
import axios from "axios";
import NewPreviewRightCustomisationDisplay from "./NewPreviewRightCustomisationDisplay";
import NewPreviewLeftCustomisationList from "./NewPreviewLeftCustomisationList";
import { enqueueSnackbar } from "notistack";
import { useDispatch, useSelector } from "react-redux";
import { setPreviewCustomisations } from "../../redux/slices/previewCustomisationsSlice";
import { extend } from "dayjs";

const NewPreviewUI = ({
  setshowmodel,
  customisationId,
  setCustomisationId,
  targetScreenWidth,
  targetScreenHeight,
  layoutItem,
}) => {
  const [attempts, setAttempts] = useState(0);
  const [errorGettingPreview, seterrorGettingPreview] = useState(false);
  const [showPreviewList, setshowPreviewList] = useState(false);
  const [eventName, setEventName] = useState("");
  const [getExtendedResult, setGetExtendedResult] = useState(false);
  const [fileBlob, setFileBlob] = useState(null);
  const previewCustomisations = useSelector(
    (state) => state?.previewCustomisations?.PreviewCustomisations
  );

  const headers = useSelector((state) => state.header);

  const curremms = useSelector((state) => state.curremms);
  const emmsheaders = useSelector((state) => state.emmsheader);
  const [editSearch, seteditSearch] = useState(false);
  const showPreviewListDataRef = useRef(null);
  const [templateResults, setTemplateResults] = useState(null);
  const dispatch = useDispatch();
  const setshowPreviewListData = (data) => {
    showPreviewListDataRef.current = data;
    setAttempts(0);
  };

  useEffect(() => {
    if (previewCustomisations != null && previewCustomisations.length > 0) {
      seteditSearch(false);
      setshowPreviewListData(previewCustomisations);
    }
  }, [previewCustomisations]);

  const [selectedOption, setSelectedOption] = useState(curremms.curremms?.id);
  const fetchData = async () => {
    try {
      const requestBody = {
        path: "eventcustomisation",
        query: { customisationId: `${customisationId}` },
        emmsId: selectedOption,
        body: {},
        requestType: "GET",
        headers: emmsheaders?.emmsheaders?.headers,
      };

      const api = localStorage.getItem("api");
      const response = await axios.post(
        `${api}/emms/piggyback`,
        requestBody,
        headers
      );

      if (response?.data?.customisations?.length > 0) {
        setEventName(response?.data?.eventCustomisationName);
        const newCustomisations = response.data.customisations;

        if (
          !showPreviewListDataRef.current ||
          newCustomisations.length >
            (showPreviewListDataRef.current?.customisations?.length || 0)
        ) {
          setshowPreviewListData(response.data);
          setshowPreviewList(true); 

          dispatch(setPreviewCustomisations(response.data.customisations));
          setGetExtendedResult(false);
          return true; 
        }
      } else {
        console.warn("No customisations found.");
      }
      return false; 
    } catch (error) {
      console.error("Failed to fetch customisations:", error);
      setshowPreviewList(false);
      enqueueSnackbar(
        "Error fetching customisations. Please try again later.",
        {
          variant: "error",
        }
      );
      return false; 
    }
  };

  const makeAttempts = async (attempts = 0) => {
    if (attempts >= 8) {
      if (!showPreviewListDataRef.current) {
        seterrorGettingPreview(true);
        enqueueSnackbar(
          "Failed to fetch customisations after multiple attempts.",
          {
            variant: "error",
          }
        );
      }
      return;
    }

    const success = await fetchData();

    if (!success) {
      setTimeout(() => makeAttempts(attempts + 1), 4000);
    } else {
      console.log("Fetch successful.");
    }
  };
  useEffect(() => {
    
    fetchExtendedResults();
  }, [getExtendedResult]);

  const fetchExtendedResults = async () => {
    if (getExtendedResult) {
      const api = localStorage.getItem("api");

      const meetingObj = JSON.parse(localStorage.getItem("MeetingObject"));
     

      let formData = new FormData();

      try {
        const requestBody = {
          path: "eventcustomisation/extendedresults",
          query: {
            eventName: `${eventName}`,
            customisationId: `${customisationId}`,
            extendedResults: true,
          },
          emmsId: selectedOption,
          body: {},
          requestType: "GET",
          headers: emmsheaders?.emmsheaders?.headers,
        };
       
        formData.append("jsonData", JSON.stringify(requestBody));

        const response = await axios.post(
          `${api}/emms/piggyback`,
          requestBody,
          headers
        );

        await makeAttempts(0);
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    makeAttempts(0);
  }, []);

  return (
    <div className="newPreviewUIContainer">
      <NewPreviewLeftCustomisationList
        editSearch={editSearch}
        errorGettingPreview={errorGettingPreview}
        seterrorGettingPreview={seterrorGettingPreview}
        seteditSearch={seteditSearch}
        setshowmodel={setshowmodel}
        setshowPreviewList={setshowPreviewList}
        setGetExtendedResult={setGetExtendedResult}
        customisationId={customisationId}
        setCustomisationId={setCustomisationId}
        showPreviewListData={showPreviewListDataRef.current}
      />
      <NewPreviewRightCustomisationDisplay
        showPreviewListData={showPreviewListDataRef.current}
        customisationId={customisationId}
        setCustomisationId={setCustomisationId}
        targetScreenWidth={targetScreenWidth}
        targetScreenHeight={targetScreenHeight}
        layoutItem={layoutItem}
      />
    </div>
  );
};

export default NewPreviewUI;
